var map = {
	"./administrator.svg": 1444,
	"./bell.svg": 8619,
	"./company.svg": 1492,
	"./dashboard.svg": 8413,
	"./help.svg": 9174,
	"./logout.svg": 5195,
	"./permission.svg": 7834,
	"./setting.svg": 4056,
	"./user_settings.svg": 3530
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2498;